<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                    <v-container>
                        <v-row class="mt-5">
                            <v-col cols="11" md="3" class="mt-n5 d-flex">
                                <v-text-field v-if="existe==''" class='casilla_beige text-body-2' v-model="sku" label="Sku" dense rounded></v-text-field>
                                <v-text-field v-else class='casilla_grey text-body-2' v-model="sku" label="Sku" dense rounded readonly></v-text-field>
                                <v-btn @click="searchProducts()" class="mt-1 ml-2" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                            </v-col>
                            <v-col cols="12" md="7" class="mt-n5">
                                <v-alert class='text-body-2' v-if="existe=='si'" shaped dense text type="success">
                                    Existe !!!
                                </v-alert>
                                <v-alert class='text-body-2' v-else-if="existe=='no'" shaped dense text type="warning">
                                    Nueva !!!
                                </v-alert>
                                <v-alert class='text-body-2' v-else dense shaped text type="info">
                                    Selecciona Producto o Material !!!
                                </v-alert>
                            </v-col>
                            <v-col cols="12" md="2" class="mt-n5 text-end">
                                    <strong class="mt-1">Editar Producto</strong>
                                    <v-btn @click="d_products=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>                                
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-row class="mt-3">
                                <v-col cols="12" md="7" class="mt-n3">
                                    <v-text-field class='casilla_grey text-body-2' v-model="producto" label="Producto" dense rounded readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" class="mt-n3">
                                    <v-text-field class='casilla_grey text-body-2' v-model="barra" label="Cod. Barra" dense rounded readonly></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-3">
                                <v-col cols="12" md="2" class="mt-n3">
                                    <v-text-field class='casilla_grey text-body-2' v-model="medida" label="Medida" dense rounded readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" class="mt-n3">
                                    <v-text-field class='casilla_grey text-body-2' v-model="marca" label="Marca" dense rounded readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" class="mt-n3">
                                    <v-text-field class='casilla_grey text-body-2' v-model="modelo" label="Modelo" dense rounded readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3" class="mt-n3">
                                    <v-text-field class='casilla_grey text-body-2' v-model="serie" label="Serie" dense rounded readonly></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-3">
                                <v-col cols="12" md="3" class="mt-n3">
                                    <v-text-field class='casilla_grey text-body-2' v-model="critico" label="Stock Critico" dense rounded readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" md="2" class="mt-n3">
                                    <v-text-field class='casilla_grey text-body-2' v-model="estado" label="Estado" dense rounded readonly></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                                        <v-container>
                                            <v-row class="mt-7">
                                                <v-col cols="12" md="7" class="mt-n7">
                                                    <v-alert class='text-body-2' dense shaped text type="info">
                                                        Crear Bodegas
                                                    </v-alert>
                                                </v-col>
                                                <v-col cols="12" md="5" class="mt-n7 d-flex">                                                    
                                                    <v-select class='casilla_beige  text-caption' v-model="bodega" :items="bodegas" label="Bodega" item-text="bodega" item-value="id" dense rounded></v-select>
                                                    <v-btn @click="d_bodega=true" fab class="ml-2" color="indigo" small dark><v-icon>add</v-icon></v-btn>                                             
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-sheet>
                                </v-col>
                            </v-row>
                            <v-row class="mt-3">
                                <v-col cols="12" md="12" class="mt-n3">
                                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                                        <v-container>
                                            <h5>Movimientos de Ajuste</h5>
                                            <v-row class="mt-5">
                                                <v-col cols="12" md="4" class="mt-n3">
                                                    <v-select class='casilla_beige text-body-2' v-model="movimiento" :items="movimientos" label="Movimiento" dense rounded></v-select>
                                                </v-col>
                                                <v-col cols="12" md="4" class="mt-n3">
                                                    <v-select v-if="movimiento!='Ingreso'" @change="search_stock()" class='casilla_beige text-body-2' v-model="bodega_origen" :items="bodegas" label="Bodega Origen" item-text="bodega" item-value="id" dense rounded></v-select>
                                                    <v-select v-else class='casilla_grey text-body-2' v-model="bodega_origen" :items="bodegas" label="Bodega Origen" item-text="bodega" item-value="id" dense rounded disabled></v-select>
                                                    <h6 class="ml-6 mt-1">Stock: {{ total_stock }}</h6>
                                                </v-col>
                                                <v-col cols="12" md="4" class="mt-n3">
                                                    <v-select v-if="movimiento!='Egreso'" class='casilla_beige text-body-2' v-model="bodega_destino" :items="bodegas" label="Bodega Destino" item-text="bodega" item-value="id" dense rounded></v-select>
                                                    <v-select v-else class='casilla_grey text-body-2' v-model="bodega_destino" :items="bodegas" label="Bodega Destino" item-text="bodega" item-value="id" dense rounded disabled></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row class="mt-5">
                                                <v-col cols="6" md="2" class="mt-n5">
                                                    <v-text-field @keypress="onlyDecimal" class='casilla_beige text-body-2' v-model="cantidad" label="Cantidad" dense rounded></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="10" class="mt-n5">
                                                    <v-text-field class='casilla_beige text-body-2' v-model="observa" label="Observacion" dense rounded></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-sheet>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="4" class="mt-2 text-center">
                            <div v-if="imgSrc==''" >
                                <img src="@/assets/no_image.jpg" width="300" height="300"/>
                            </div>
                            <div v-else>
                                <img :src="imgSrc" width="300" height="300"/>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
            <v-container>
                <v-row>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="2">
                        <v-btn @click="clsInput()" color="teal" rounded dark small block>Limpiar</v-btn>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-btn v-if="btn_grabado!=true" @click="goSave()" color="teal" rounded dark small block>Grabar</v-btn>
                        <v-btn v-else color="grey" rounded dark small block>Grabar</v-btn>
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                </v-row>
            </v-container>
        </v-container>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- lista de productos -->
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Productos</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="products_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProducts" dense dark height="400px" fixed-header
                    :search="products_search" :headers="products_titulo" :items="products_lista" 
                    :page.sync="products_page" :items-per-page="products_itemsPerPage"  
                    @page-count="products_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.codigo="{ item }">
                        <v-chip small>
                            {{ item.codigo }}
                        </v-chip>
                    </template>
                </v-data-table>
                <v-pagination v-model="products_page" :length="products_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- bodegas -->
        <v-dialog v-model="d_bodega" transition="dialog-bottom-transition" max-width="450">
             <v-card>
                <v-card-title>
                    Crear Bodega
                <v-spacer></v-spacer>
                    <v-icon @click="d_bodega=false" color="error">close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="mt-5">
                        <v-col cols="1" md="2"></v-col>
                        <v-col cols="10" md="8">
                            <v-text-field label="Nueva Bodega" class='casilla_beige text-body-2' v-model="nueva_bodega" dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="1" md="2"></v-col>
                        <v-col cols="12">
                            <v-btn @click="add_bodega()" small color="teal" block dark rounded>Agregar Bodega</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-5 mb-2"></v-divider>
                    <h4>Mis Bodegas</h4>
                    <div class="scroller">
                        <v-simple-table fixed-header dense>
                            <thead>
                                <tr>
                                    <th id="back" class="text-center">Id</th>
                                    <th id="back" class="text-start">Bodega</th>
                                    <th id="back">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in bodegas" :key="item.id">
                                    <td class="text-center">
                                        <span class="text-caption">{{ item.id }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.bodega }}</span>
                                    </td>
                                    <td class="text-center">
                                        <v-icon v-if="parseInt(item.id)!=1" @click="verifyBodega(item)" color="red" small>delete</v-icon>
                                        <v-icon v-else color="grey" small>do_not_disturb</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
             </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
form img{
  width: 150px;
  height: 150px;
  border-radius: 5%;
  border: 1px solid lightgray;
}
form div:first-child{
  align-items: center;
}
form div:first-child input{
  display: none;
}
form div:first-child label{
  /* background: #1F5F74;
  color: white; 
    border-radius: 3px; 
  padding: 6px 20px;*/
  cursor: pointer;
}
form input{
  padding: 8px 20px;
  border: 1px solid #AAA;
  border-radius: 3px;
}
.text-size >>> td {
    font-size: 9pt !important;
    height: 30px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_table {
    background-color: beige; 
    height: 25px;
    border: 1px solid lightgray;
}
.scroller {
  height: 18em;
  line-height: 1em;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  /*border: 1px solid lightgray;*/
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Ajuste',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    existe:'',
    id_producto:0,
    tipo:'producto',
    sku:'',
    producto:'',
    marca:'',
    modelo:'',
    serie:'',
    medida:'',
    barra:'',
    estado:'',
    btn_grabado:false,
    bloqueo:null,
    loading:false,

    imgSrc:"" ,
    imgDefault:'',
    d_products:false,
    products_titulo: [
      { text: 'Sku', align: 'start', sortable: true, value: 'codigo' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Marca', align: 'start', sortable: true, value: 'txt_marca' },
      { text: 'Modelo', align: 'start', sortable: true, value: 'modelo' },
      { text: 'Serie', align: 'start', sortable: true, value: 'serie' },
    ],
    products_lista: [],
    products_page: 1,
    products_pageCount: 0,
    products_itemsPerPage: 1000000,
    products_search:'',

    critico:'0',
    bodega:0,
    bodegas:[],

    d_bodega:false,
    nueva_bodega:'',


    movimiento:null,
    movimientos:['Ingreso', 'Egreso', 'Traspaso'],
    bodega_origen:null,
    bodega_destino:null,
    cantidad:0,
    observa:'',
    total_stock:0,

  }),
  async mounted(){
    this.loading=true;
    this.user=localStorage.getItem('dops_myuser');
    this.apikey=localStorage.getItem('dops_apiKey');
    this.contrato=localStorage.getItem('dops_mycontrato');
    this.bloqueo = await this.myPermiso(6);
    if(parseInt(this.bloqueo)!=0){
        await this.searchBodegas()
        await this.searchProductList()
    }
    this.loading=false;
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async searchBodegas(){
        this.bodegas=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                bodega : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/bodegas/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.bodegas=datos
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async searchProductList(){
        this.products_lista=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.products_lista=datos
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async handleProducts(item){
        this.loading=true;
        this.existe="si";
        this.id_producto = item.ID;
        this.sku = item.codigo
        this.producto = item.producto
        this.marca = item.txt_marca
        this.modelo = item.modelo
        this.serie = item.serie
        this.medida = item.medida
        this.barra = item.barra
        this.estado = item.estado
        this.critico = item.critico
        //this.bodega = item.bodega
        this.d_products = false;
        this.movimiento=null;
        this.bodega_origen=null;
        this.bodega_destino=null;
        this.cantidad=0;
        this.observa='';
        this.total_stock=0;
        this.loading=false;
        await this.searchImages(item.codigo)
    },
    async searchImages(code){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku : code
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/images/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                const element = datos[0];
                if(element.img1!=''){ 
                    this.imgSrc = element.img1;
                }
            }            
        } catch (error) {
            console.log(error)
        }
    }, 
    clsInput(){
        this.existe='';
        this.tipo='producto';
        this.sku='';
        this.producto='';
        this.marca='';
        this.modelo='';
        this.serie='';
        this.medida='';
        this.barra='';
        this.estado='';
        this.btn_grabado=false;
        this.critico='0';
        this.bodega=0;
        this.imgSrc='';
        this.movimiento=null;
        this.bodega_origen=null;
        this.bodega_destino=null;
        this.cantidad=0;
        this.observa='';
        this.total_stock=0;
    },
    async searchProducts(){
        if(this.sku!='all' && this.sku!='' && this.sku!=null){
            this.loading=true;
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    sku :  this.sku
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    const element = datos[0];
                    this.id_producto = element.ID;
                    this.sku = element.codigo
                    this.producto = element.producto
                    this.marca = element.txt_marca
                    this.modelo = element.modelo
                    this.serie = element.serie
                    this.medida = element.medida
                    this.barra = element.barra
                    this.estado = element.estado
                    this.critico = element.critico
                    //this.bodega = element.bodega
                    this.existe='si';
                } else {
                    if(datos[0].existe=='no'){
                        this.existe='no';
                    } else {
                        this.color_snack='error';
                        this.mensaje='Inconsistencia en los datos, informar a soporte';
                        this.snack=true
                    }
                }
            } catch (error) {
                console.log(error);
                this.color_snack='error';
                this.mensaje='Algo salio mal, informar a soporte';
                this.snack=true
            }
            this.loading=false;
            if(this.existe=='si'){
                await this.searchImages(this.sku);
            }
        } else {
            this.color_snack='error';
            this.mensaje='Sku ingresado no existe';
            this.snack=true            
        }
    },
    async goSave(){
        if(this.sku!='' && this.sku!=null && this.existe=='si'){
            if(this.movimiento!=null){
                this.loading=true;
                await this.save_stock();
                this.loading=false;                
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese movimento';
                this.snack=true                     
            }
        } else {
            this.color_snack='error';
            this.mensaje='Ingrese Sku producto';
            this.snack=true 
        }
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    async search_stock(){
        if(this.sku!=0 && this.sku!=null){
            if(this.bodega_origen!=0 && this.bodega_origen!=null){
                this.total_stock=0;
                try {
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        contrato: this.contrato,
                        user:  this.user,
                        codigo:  this.sku,
                        bodega: this.bodega_origen
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/stock/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        this.total_stock = datos[0].stock;
                    }
                } catch (error) {
                    console.log(error)
                }
            } 
        } else {
            this.color_snack='error';
            this.mensaje='Ingrese sku del producto';
            this.snack=true 
        }
    },
    async save_stock(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const hoy = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
            const key = this.movimiento;
            switch (key) {
                case "Ingreso":
                    if(this.bodega_destino!='' && this.bodega_destino!=null){
                        if(this.cantidad!='' && this.cantidad!=null){
                            if(parseFloat(this.cantidad) > 0){
                                const params = {
                                    contrato : this.contrato,
                                    user :  this.user,
                                    fecha: hoy,
                                    tipo: this.tipo,
                                    codigo:  this.sku,
                                    cantidad: this.cantidad,
                                    signo: '0+',
                                    bodega: this.bodega_destino,
                                    observa: this.observa,
                                    origen: 'Ingreso'
                                };
                                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/stock/',params,{headers});
                                const datos = res.data;
                                if(datos[0].existe=='si'){
                                    this.btn_grabado=true;
                                    this.color_snack='success';
                                    this.mensaje='Movimento realizado con exito';
                                    this.snack=true 
                                } else {
                                    this.color_snack='error';
                                    this.mensaje='Movimento NO guardado';
                                    this.snack=true 
                                }
                            } else {
                                this.color_snack='error';
                                this.mensaje='Cantidad invalida';
                                this.snack=true
                            }
                        } else {
                            this.color_snack='error';
                            this.mensaje='Ingrese cantidad';
                            this.snack=true 
                        }
                    } else {
                        this.color_snack='error';
                        this.mensaje='Ingrese bodega destino';
                        this.snack=true 
                    }
                break;
                case "Egreso":
                    if(parseFloat(this.total_stock)!=0){
                        if(this.cantidad!='' && this.cantidad!=null){
                            if(parseFloat(this.cantidad) > 0){
                                if(parseFloat(this.cantidad)<=parseFloat(this.total_stock)){
                                    const params1 = {
                                        contrato : this.contrato,
                                        user :  this.user,
                                        fecha: hoy,
                                        tipo: this.tipo,
                                        codigo:  this.sku,
                                        cantidad: this.cantidad,
                                        signo: '0-',
                                        bodega: this.bodega_origen,
                                        observa: this.observa,
                                        origen: 'Egreso'
                                    };
                                    const res1 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/stock/',params1,{headers});
                                    const datos1 = res1.data;
                                    if(datos1[0].existe=='si'){
                                        this.btn_grabado=true;
                                        this.color_snack='success';
                                        this.mensaje='Movimento realizado con exito';
                                        this.snack=true 
                                    } else {
                                        this.color_snack='error';
                                        this.mensaje='Movimento NO guardado';
                                        this.snack=true 
                                    }
                                } else {
                                    this.color_snack='error';
                                    this.mensaje='Cantidad supera stock';
                                    this.snack=true
                                }
                            } else {
                                this.color_snack='error';
                                this.mensaje='Cantidad invalida';
                                this.snack=true
                            }
                        } else {
                            this.color_snack='error';
                            this.mensaje='Ingrese cantidad';
                            this.snack=true
                        }
                    } else {
                        this.color_snack='error';
                        this.mensaje='Movimiento invalido, stock en 0';
                        this.snack=true
                    }
                break;
                case "Traspaso":
                    if(this.bodega_destino!='' && this.bodega_destino!=null){
                        if(parseFloat(this.total_stock)!=0){
                            if(this.cantidad!='' && this.cantidad!=null){
                                console.log('cantidad',this.cantidad)
                                if(parseFloat(this.cantidad) > 0){
                                    if(parseFloat(this.cantidad)<=parseFloat(this.total_stock)){
                                        //primero realizamos el egreso de la bodega origen
                                        let ING = 'no';
                                        let EGR = 'no';
                                        const params2 = {
                                            contrato : this.contrato,
                                            user :  this.user,
                                            fecha: hoy,
                                            tipo: this.tipo,
                                            codigo:  this.sku,
                                            cantidad: this.cantidad,
                                            signo: '0+',
                                            bodega: this.bodega_destino,
                                            observa: this.observa,
                                            origen: 'Traspaso'
                                        };
                                        const res2 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/stock/',params2,{headers});
                                        const datos2 = res2.data;
                                        if(datos2[0].existe=='si'){ ING='si' };
                                        //segundo realizamos el egreso de la bodega origen
                                        const params3 = {
                                            contrato : this.contrato,
                                            user :  this.user,
                                            fecha: hoy,
                                            tipo: this.tipo,
                                            codigo:  this.sku,
                                            cantidad: this.cantidad,
                                            signo: '0-',
                                            bodega: this.bodega_origen,
                                            observa: this.observa,
                                            origen: 'Traspaso'
                                        };
                                        const res3 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/stock/',params3,{headers});
                                        const datos3 = res3.data;
                                        if(datos3[0].existe=='si'){ EGR = 'si' };
                                        //opcion 1
                                        if(ING=='si' && EGR=='si'){
                                            this.btn_grabado=true;
                                            this.color_snack='success';
                                            this.mensaje='Traspaso realizado con exito';
                                            this.snack=true 
                                        };
                                        if(ING=='si' && EGR=='no'){
                                            this.btn_grabado=true;
                                            this.color_snack='warning';
                                            this.mensaje='Ingreso realizado, Egreso pendiente';
                                            this.snack=true 
                                        };
                                        if(ING=='no' && EGR=='si'){
                                            this.btn_grabado=true;
                                            this.color_snack='warning';
                                            this.mensaje='Egreso realizado, ingreso pendiente';
                                            this.snack=true 
                                        };
                                        if(ING=='no' && EGR=='no'){
                                            this.color_snack='error';
                                            this.mensaje='Movimento NO realizado, intentelo mas tarde';
                                            this.snack=true 
                                        };
                                    } else {
                                        this.color_snack='error';
                                        this.mensaje='Cantidad supera stock';
                                        this.snack=true
                                    }
                                } else {
                                    this.color_snack='error';
                                    this.mensaje='Cantidad invalida';
                                    this.snack=true
                                }
                            } else {
                                this.color_snack='error';
                                this.mensaje='Ingrese cantidad';
                                this.snack=true
                            }
                        } else {
                            this.color_snack='error';
                            this.mensaje='Movimiento invalido, stock en 0';
                            this.snack=true
                        }
                    } else {
                        this.color_snack='error';
                        this.mensaje='Ingrese bodega destino';
                        this.snack=true 
                    }
                break;
            };
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, intentelo mas tarde';
            this.snack=true 
        }
    },
    async add_bodega(){
        this.loading=true;
        try {
            if(this.nueva_bodega!='' && this.nueva_bodega!=null){
                //validar que no se repita
                const validaBodega = this.bodegas.filter(res => res.bodega == this.nueva_bodega);
                if(validaBodega.length!=0){
                    this.color_snack='error';
                    this.mensaje='La bodega ya existe';
                    this.snack=true
                } else {
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        contrato : this.contrato,
                        user :  this.user,
                        bodega : this.nueva_bodega
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/bodega/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        await this.searchBodegas();
                        if(this.bodegas.length!=0){
                            const dataBodega = this.bodegas.filter(res => res.bodega == this.nueva_bodega);
                            if(dataBodega.length!=0){
                                this.bodega = dataBodega[0].id
                            }
                        }
                        this.d_bodega=false
                    }
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese nueva bodega';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
        }
        this.loading=false;
    },
    async verifyBodega(item){
        this.loading=true;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato: this.contrato,
                user:  this.user,
                bodega: item.id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/verify/bodega/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                if(parseFloat(datos[0].stock)==0){
                    await this.deleteBodega(item)
                } else {
                    this.color_snack='error';
                    this.mensaje='Bodega asignada a productos';
                    this.snack=true
                }
            }
            if(datos[0].existe=='no'){
                await this.deleteBodega(item)
            }
        } catch (error) {
            console.log(error)
        }
        this.loading=false;
    },
    async deleteBodega(item){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                bodega : item.id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/bodega/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.loading=true;
                await this.searchBodegas();
                this.loading=false;
                this.color_snack='success';
                this.mensaje='Bodega eliminada';
                this.snack=true
            }            
        } catch (error) {
            console.log(error)
        }
    },


  }
}
</script>
